export default "__VITE_ASSET__DlMbdE1h__"